import { render, staticRenderFns } from "./McsQuestionPopupComponent.vue?vue&type=template&id=7fdf25ec&"
import script from "./McsQuestionPopupComponent.vue?vue&type=script&lang=js&"
export * from "./McsQuestionPopupComponent.vue?vue&type=script&lang=js&"
import style0 from "./McsQuestionPopupComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports